import { Component, input } from '@angular/core';
import type { OnyxIconName } from '@onyx/angular';
import { OnyxDotComponent, OnyxIconComponent } from '@onyx/angular';
import { OrderStageStatus } from '../order-modal-stage-item.component';

@Component({
  selector: 'app-order-modal-stage-item-icon',
  imports: [OnyxIconComponent, OnyxDotComponent],
  templateUrl: './order-modal-stage-item-icon.component.html',
  styleUrl: './order-modal-stage-item-icon.component.scss',
  host: { '[class]': `status()` },
})
export class OrderModalStageItemIconComponent {
  public readonly status = input.required<OrderStageStatus>();
  public readonly icon = input.required<OnyxIconName>();

  protected readonly OrderStageStatus = OrderStageStatus;
}
